<template lang="pug">
.vprStartworkComopnent
  vpr-startwork-instruction(
    v-if="isInstructionStep"
    @do-vpr="onDoVpr"
  )
  vpr-startwork-player(
    v-else-if="isVprStep"
  )
  vpr-startwork-player-results(
    v-else-if="isResultsStep"
  )

</template>

<script>
import { computed, inject, ref } from '@vue/runtime-core'
import VprStartworkInstruction from './VprStartworkInstruction'
import VprStartworkPlayer from './VprStartworkPlayer'
import VprStartworkPlayerResults from './VprStartworkPlayerResults'

const STEP_INSTRUCTION = 'instruction'
const STEP_VPR = 'vpr'
const STEP_RESULTS = 'results'

export default {
  components: {
    VprStartworkInstruction,
    VprStartworkPlayer,
    VprStartworkPlayerResults
  },
  setup () {
    const controller = inject('controller')

    const step = ref(
      controller.isVprCompleted.value
        ? STEP_RESULTS
        : STEP_INSTRUCTION
    )
    const setStep = val => { step.value = val }

    return {
      isInstructionStep: computed(() => step.value === STEP_INSTRUCTION),
      isVprStep: computed(() => step.value === STEP_VPR),
      isResultsStep: computed(() => step.value === STEP_RESULTS),
      onDoVpr: () => setStep(STEP_VPR)
    }
  }
}
</script>

<style lang="sass" scoped>
.vprStartworkComopnent

</style>
